export enum SelectScreenCardTypes {
  Purchased = "purchased",
  Empty = "empty",
  Blocked = "blocked",
}
